import Soundcloud7 from './Soundcloud7'
export default Soundcloud7
